import React from "react"

import { Row, Col, Form, Button } from "react-bootstrap"

const MultiSmoke = props => {
  const { values, setSmoker, nextStep } = props
  

  const setSmokerAndNext = smoker => {
    setSmoker(smoker)
    nextStep()
  }

  return (
    <div style={{ textAlign: "center" }}>
      {/* <---------------Q1--------------->*/}
      <Row style={{ justifyContent: "center" }}>
        <Col xs={12} sm={6}>
          <Form.Label className="button-question">Do you smoke?</Form.Label>

          {/* <---------------BUTTON--------------->*/}
          <Row>
            <Col
              sm={4}
              xs={{ offset: 2, span: 4 }}
              style={{ textAlign: "center" }}
            >
              <div>
                <Button
                  // type="button"
                  className="orange-btn"
                  onClick={() => setSmokerAndNext(true)}
                  active={values.smoker === true ? true : false}
                >
                  <i className="fas fa-smoking fa-2x"></i>
                </Button>
              </div>
              <Form.Label className="button-label">Yes</Form.Label>
            </Col>
            {/* <---------------BUTTON--------------->*/}
            <Col sm={4} xs={4} style={{ textAlign: "center" }}>
              <div>
                <Button
                  // type="button"
                  className="orange-btn"
                  onClick={() => setSmokerAndNext(false)}
                  active={values.smoker === false ? true : false}
                >
                  <i className="fas fa-smoking-ban fa-2x"></i>
                </Button>
              </div>
              <Form.Label className="button-label">No</Form.Label>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default MultiSmoke
